import { FerramentaVideoService } from 'core/http/service/ferramentaVideo/FerramentaVideo.service';
import useFetch from 'hooks/useFetch';
import { IFVContainer } from 'pages/ferramentaVideo/interfaces/FVContainer.interface';
import React from 'react';
import Styled from './SessionFerramentaVideo.style';
import { bucketS3, caminhoAnexosGeneralFiles } from 'constants/EnvironmentData';
import { YellowButton } from 'components/UI/Buttons';
import { useHistory } from 'react-router-dom';

interface SessionFerramentaVideoProps {
    solucaoId: number;
}

const serviceFerramentaVideo = new FerramentaVideoService();

const SessionFerramentaVideo: React.FC<SessionFerramentaVideoProps> = ({ solucaoId }) => {
    const history = useHistory();
    const [ferramentas, setFerramentas] = React.useState<IFVContainer[]>([]);
    const [urlLogoSolucao, setSolucao] = React.useState<string>('');

    const getS3BaseUrl = (): string => {
        return bucketS3() + caminhoAnexosGeneralFiles();
    };

    const goToFerramenta = (url: string) => {

        //remover todas as / caso tenha
        url = url.replaceAll('/', '').toLowerCase();

        history.push('/videos/' + url + '?redirect=' + window.location.pathname);
    };

    useFetch(async () => {
        const response = await serviceFerramentaVideo.fetchContainersBySolutionId(solucaoId);
        setFerramentas(response.data);
        if (response.data.length > 0) {
            setSolucao(response.data[0].codigoSolucao?.logo || '');
        }
    }, [solucaoId]);


    if(ferramentas.length === 0){
        return <></>
    }


    return (
        <Styled.Container img={getS3BaseUrl() + 'anexo_storage_files_12506864710722349518.png_2025-08-27-1756301229116.png'}>
            <Styled.Content>
                <img src={getS3BaseUrl() + urlLogoSolucao} style={{ width: '155px' }} alt="" />
                <Styled.Body twoColumns={ferramentas.length > 1}>
                    {ferramentas.map(ferramenta => (
                        <Styled.Ferramenta.Container key={ferramenta.id}>
                            <Styled.Ferramenta.Title>{ferramenta.title}</Styled.Ferramenta.Title>
                            <Styled.Ferramenta.Description dangerouslySetInnerHTML={{ __html: ferramenta.description }} />
                            <YellowButton
                                style={{
                                    maxWidth: 'fit-content',
                                    height: '52px',
                                    minHeight: '52px',
                                    textTransform: 'uppercase',
                                    fontSize: '20px',
                                    borderRadius: '8px',
                                    order: 0,
                                }}
                                onClick={() => goToFerramenta(ferramenta.url)}
                                aria-label={ferramenta.altUrl ?? "Acessar ferramenta " + ferramenta.title}
                            >
                                Comece a assistir
                            </YellowButton>
                        </Styled.Ferramenta.Container>
                    ))}
                </Styled.Body>
            </Styled.Content>
        </Styled.Container>
    );
};

export default SessionFerramentaVideo;
